export default __webpack_public_path__ + "static/media/interaction-preview.8ea0b553.png";